import { SidebarTrigger } from '../components/ui/sidebar';
import { useUserRoles } from '../hooks/useUserRoles';
import { useIsMobileApp } from '../hooks/use-mobile';
import MobileHome from './mobile/MobileHome';
import WelcomeHeader from '../components/home/WelcomeHeader';
import WhatEllieCanSee from '../components/home/WhatEllieCanSee';
import OpenRequests from '../components/home/OpenRequests';
import KnowledgeBaseAttention from '../components/home/KnowledgeBaseAttention';

export default function Home() {
  // ReadOnly_Partner sees the greeting and Ask Ellie, nothing else: requests,
  // the knowledge base and the source list are all tenant-internal. The check is
  // positive so a user whose roles haven't loaded gets the narrow page rather
  // than a flash of the full one.
  const { canViewDataManagement } = useUserRoles();
  const isMobileApp = useIsMobileApp();

  // The phone home screen is a different page, not a narrower one — see
  // MobileHome for what it drops and why.
  if (isMobileApp) return <MobileHome />;

  return (
    <div className="h-full overflow-y-auto bg-page-bg">
      <div className="md:hidden p-3">
        <SidebarTrigger className="h-5 w-5" />
      </div>

      <WelcomeHeader />

      {canViewDataManagement && (
        <div className="p-8 grid grid-cols-1 lg:grid-cols-3 gap-6 items-start">
          <div className="lg:col-span-2 flex flex-col gap-6">
            <OpenRequests />
            <KnowledgeBaseAttention />
          </div>
          <div className="lg:col-span-1">
            <WhatEllieCanSee />
          </div>
        </div>
      )}
    </div>
  );
}
